<template>
    <div
        id="confirm-dialog"
        class="modal"
        :class="{ fade: !isVisible, show: isVisible }"
        tabindex="0"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h4>{{ title }}</h4>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label
                                class="control-label"
                                for="sendEmail"
                            >Notify subscribed users of new incident</label>
                            <b-form-radio-group
                                v-model="sendNotification"
                                :options="availableSendNotifitionOptions"
                                name="radio-inline"
                                stacked
                                plain
                                class="send-notification-group"
                            ></b-form-radio-group>
                            <label
                                class="control-label"
                                for="sendEmail"
                            >Notify subscribed users of new incident</label>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label class="control-label" for="sendEmail">Message</label>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <textarea
                                style="resize:none"
                                class="form-control"
                                cols="40"
                                name="message"
                                placeholder="Message..."
                                rows="10"
                                v-model="messageModel"
                            ></textarea>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click.prevent="cancel()">Close</button>
                    <button
                        type="button"
                        class="btn btn-danger"
                        :disabled="messageModel.length === 0"
                        @click.prevent="confirm()"
                    >{{ dialogAction }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            messageModel: "",
            sendNotification: "1",
            isEmpty: true,
            availableSendNotifitionOptions: [
                { value: "1", text: "Send notification" },
                { value: "0", text: "Don't send notification" }
            ]
        }
    },
    props: {
        message: String,
        title: String,
        dialogAction: String,
        isVisible: Boolean
    },
    methods: {
        confirm() {
            this.$emit("close", {
                isConfirmed: true,
                message: this.messageModel,
                sendNotification: this.sendNotification
            })
        },
        cancel() {
            this.$emit("close", {
                isConfirmed: false
            })
        }
    },
    watch: {
        message: function(val) {
            this.messageModel = val
        }
    }
}
</script>

<style>
.form-check-description {
    padding-left: 5px;
    font-weight: 500;
}
</style>

<style scoped>
.modal {
    text-align: center;
    padding: 0;
    background: rgba(0, 0, 0, 0.6);
}

.modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
}

.modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
}

.form-check-description {
    padding-left: 5px;
}

.send-notification-group:focus {
    outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageDialog.vue